export enum RegisterCompleteState {
    NotTaken = 1,
    Incomplete = 2,
    Complete = 3
}